var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-no-data"},[_c('a-empty',{attrs:{"description":_vm.title,"image":_vm.simpleImage?'https://ybpt-public.obs.cn-north-4.myhuaweicloud.com/client/logo/icon_permissions.png':false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }